import defineComponent from 'flight';
import memberInfo from 'static/script/app/data/member-info';

function BiddingForm() {
    this.defaultAttrs({
        biddingForm: '.bidding-form',
        biddingFormHeader: '[data-bidding-new-bid-information]',
        biddingFormHeaderTemplate: '[data-bidding-confirm-header-template]',
        bidAmountField: '[data-submit-bid-amount-field]',
        buttons: '.view-item-button, .bidding-button, [data-bidding-button]'
    });

    this._handleClientEvent = function (evt, data) {
        let selectedBid = this.select('bidAmountField').val();
        if (selectedBid < data.NextValidBidAmount) {
            let headerTemplate = this.select('biddingFormHeaderTemplate').html();
            let headerHtml = _.template(headerTemplate);
            this.select('biddingFormHeader').replaceWith(headerHtml(data));
            this.select('biddingForm').addClass('bidding-form-confirm-bid');
        }
    };

    this._gaLogButtonText = function (evt) {
        if (!memberInfo.isLoggedIn) {
            return;
        }
        let btn = $(evt.target);
        let text = btn.attr('data-bidding-button') || btn.text();
        let category = btn.hasClass('view-item-button') ? 'View item' : 'Bidding';
        this.trigger('analytics:track-event', {
            category: category,
            action: 'Bid button',
            label: text.trim(),
            userTriggered: true
        });
    };

    this.after('initialize', function () {
        this.on(document, 'data:notifications:on-bid-update', this._handleClientEvent);
        this.on('click', {
            buttons: this._gaLogButtonText
        });
    });
}

module.exports = defineComponent.component(BiddingForm);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/bidding-form.js